import { node, oneOfType, arrayOf, string } from 'prop-types';

import styles from './Container.scss';

export const Container = ({ children, className = '', ...props }) => (
  <div className={className || styles.Container} {...props}>
    {children}
  </div>
);

Container.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired,
  className: string,
};
